import { useEffect, useRef } from 'react';
import { useForm, useField } from 'react-final-form';
import PropTypes from 'prop-types';

const ResetOnFieldChange = ({ watchField, resetFields = [], type = 'always', includingFn }) => {
  const form = useForm();
  const {
    input: { value: watchedValue },
  } = useField(watchField);
  const isFirstRun = useRef(true);

  useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false;
      return;
    }

    const resetField = (field) => {
      const currentValue = form.getState().values[field];
      if (currentValue) {
        form.change(field, undefined);
      }
    };

    if (type === 'always') {
      resetFields.forEach(resetField);
    } else if (type === 'falsy') {
      if (!watchedValue) {
        resetFields.forEach(resetField);
      }
    } else if (type === 'exclusion') {
      resetFields.forEach((field) => {
        const currentValue = form.getState().values[field];
        if (
          currentValue &&
          (!watchedValue || (Array.isArray(watchedValue) && !includingFn?.(currentValue, watchedValue)))
        ) {
          resetField(field);
        }
      });
    }
  }, [watchedValue]);

  return null;
};

ResetOnFieldChange.propTypes = {
  watchField: PropTypes.string.isRequired,
  resetFields: PropTypes.arrayOf(PropTypes.string).isRequired,
  type: PropTypes.oneOf(['always', 'falsy', 'exclusion']),
  includingFn: (props, propName) => {
    const { type } = props;
    const fn = props[propName];

    if (type === 'exclusion' && typeof fn !== 'function') {
      return new Error(`You must provide ${propName} when type="exclusion".`);
    }
    return null;
  },
};

export default ResetOnFieldChange;
